import React, { useState } from "react";
import { VisibilityOff, VisibilityOn } from "../../assets/icons";
import Input from "../ui/input";

const EyeIcon = ({ open, onClick }) => (
  <span style={{ cursor: "pointer", display: "flex" }} onClick={onClick}>
    {open ? <VisibilityOn /> : <VisibilityOff />}
  </span>
);

const InputPassword = ({ label, placeholder, ...inputProps }) => {
  const [show, setShow] = useState(false);
  return (
    <Input
    fullWidth
      label={label}
      placeholder={placeholder}
      type={show ? "text" : "password"}
      {...inputProps}
      icon={<EyeIcon open={show} onClick={() => setShow(!show)} />}
      iconPosition={'right'}
    />
  );
};
export default InputPassword;